import {
  useCallback,
  type MutableRefObject,
  type LegacyRef,
  type SetStateAction,
  type Dispatch,
  type RefCallback,
} from 'react';

/**
 * If you have multiple references (e.g. from different hooks) you need to apply to
 * the same element, you can use the `useMergeRefs` hook to combine them into one
 * reference.
 * @public
 */
export function useMergeRefs<T = unknown>(
  refs: Array<
    | MutableRefObject<T>
    | LegacyRef<T>
    | Dispatch<SetStateAction<T | null>>
    | undefined
  >,
): RefCallback<T> {
  return useCallback((value) => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref !== undefined && ref !== null) {
        (ref as MutableRefObject<T | null>).current = value;
      }
    }
  }, refs); // eslint-disable-line react-hooks/exhaustive-deps
}
